import { getDesiredAssignmentsSchema } from '../../intune-utlity';
import { getConfigurationPolicySettingsForChromeSchema } from '../helper';
import { DeviceConfigurationWindowsChromeBlockPasswordSavingSchema } from './model';

export const updateSchema = (
    formValue: any,
    schema: DeviceConfigurationWindowsChromeBlockPasswordSavingSchema,
): any => {
    // update your schema here
    schema.contains.properties.description.const = formValue.policy.description;

    schema.contains.properties.assignments = getDesiredAssignmentsSchema(formValue);

    schema.contains.properties.settings = getConfigurationPolicySettingsForChromeSchema(formValue.settings);
    return schema;
};
